import React from "react";
import axios from "axios";
import { account } from "shared/storeInfo";
import { gtmPushCustomEvent } from "shared/analytics/googleTagManager";

export default class Favorite extends React.Component {
  constructor(props) {
    super(props);

    const { isFavorite } = props;
    let { favoriteCount } = props;
    const productFavorized = !!isFavorite;
    favoriteCount = favoriteCount || 0;
    let clickOnProductHeartHandler;
    if (productFavorized) {
      clickOnProductHeartHandler = this.unfavorProduct.bind(this);
    } else {
      clickOnProductHeartHandler = this.favorProduct.bind(this);
    }
    this.state = {
      productFavorized,
      favoriteCount,
      clickOnProductHeartHandler,
    };
  }

  favorProduct() {
    this.requestServer("POST")
      .then(() => {
        this.setState({
          productFavorized: true,
          favoriteCount: this.state.favoriteCount + 1,
          clickOnProductHeartHandler: this.unfavorProduct.bind(this),
        });
        const product = { ...this.props.product };
        this.props.setProductWithNewFavorites(product);
        this.trackActionOnProduct("Create");
        this.trackActionFromAccount("CreateBy");
      })
      .catch(() => {
        this.trackActionOnProduct("Server Error");
      });
  }

  unfavorProduct() {
    this.requestServer("DELETE")
      .then(() => {
        this.setState({
          productFavorized: false,
          favoriteCount: this.state.favoriteCount - 1,
          clickOnProductHeartHandler: this.favorProduct.bind(this),
        });
        this.trackActionOnProduct("Delete");
        this.trackActionFromAccount("DeletedBy");
      })
      .catch(() => {
        this.trackActionOnProduct("Server Error");
      });
  }

  requestServer(method) {
    return axios({
      method,
      url: "/merchants/favorites",
      data: { product_id: this.props.product.id },
    });
  }

  trackActionOnProduct(eventAction) {
    gtmPushCustomEvent("Favorite", eventAction, this.props.product.name);
  }

  trackActionFromAccount(eventAction) {
    gtmPushCustomEvent("Favorite", eventAction, account("id"));
  }

  render() {
    const heart = !(account("type") === "MerchantAccount") ? (
      <span className="favorite">
        <i className="fa fa-heart disabled" />
      </span>
    ) : (
      // REFACTOR: fix this selectively disabled rule next time when working on
      //           this part
      /* eslint-disable jsx-a11y/click-events-have-key-events,
                        jsx-a11y/no-static-element-interactions */
      <span
        onClick={this.state.clickOnProductHeartHandler}
        className="favorite"
      >
        <i
          className={
            this.state.productFavorized ? "fa fa-heart" : "fa fa-heart-o"
          }
        />
      </span>
      /* eslint-enable jsx-a11y/click-events-have-key-events,
                       jsx-a11y/no-static-element-interactions */
    );

    return (
      <div className="favorites-column pull-right">
        {this.state.favoriteCount !== 0 && (
          <span className="favorites-counter small">
            {this.state.favoriteCount}
          </span>
        )}
        {heart}
      </div>
    );
  }
}
